import gql from 'graphql-tag';

export const ContentAccessDetailsQuery = gql`
	query ContentAccessDetailsQuery(
		$contentId: ID!
		$first: Int
		$after: String
		$filterText: String
	) {
		contentPermissions(contentId: $contentId) {
			subjectsWithEffectiveContentPermissions(
				first: $first
				after: $after
				filterText: $filterText
			) {
				groupCount
				userCount
				nodes {
					id
					permissions
					type
					displayName
					group {
						id
						name
						permissionType
					}
					user {
						accountId
						displayName
						email
						permissionType
						profilePicture {
							width
							height
							isDefault
							path(type: ABSOLUTE)
						}
					}
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
		singleContent(id: $contentId) {
			id
			title
			type
			links {
				webui
			}
		}
	}
`;
